(() => {
  'use strict';
  if (window.FTCNovemberPromo) return;
  const configNode = document.getElementById('ftc-november-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const rawFetch = window.fetch.bind(window);
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  const variants = config.variants.filter(v => v.available);
  const eligible = new Set(config.eligibleProductIds.map(Number));
  let chosen = variants[0]?.id || 0;
  let chosenByCustomer = false;
  let running = null;
  let rerun = false;
  let timer;
  let lastCart;
  let sections = null;
  let refreshWanted = false;
  const automatic = item => item.properties?._FTC_USA_GIFT === 'true';
  const rate = currency => {
    if (currency === config.currency) return 1;
    const live = Number(window.Shopify?.currency?.rate);
    if (window.Shopify?.currency?.active === currency && live > 0) return live;
    const fallback = Number(config.giftPricePresentment) / Number(config.giftPriceBase);
    return currency === config.presentmentCurrency && fallback > 0 ? fallback : 0;
  };
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: lastCart?.currency || config.currency }).format(cents / 100);
  const state = cart => {
    const gifts = cart.items.filter(automatic);
    const giftTotal = cart.items.reduce((sum, item) => sum + (automatic(item) || Number(item.product_id) === Number(config.giftProductId) ? Number(item.final_line_price || 0) : 0), 0);
    const subtotal = Math.max(0, Number(cart.total_price || 0) - giftTotal);
    const count = cart.items.reduce((sum, item) => sum + (!automatic(item) && eligible.has(Number(item.product_id)) ? item.quantity : 0), 0);
    const conversion = rate(cart.currency);
    const threshold = Math.round(config.threshold * conversion);
    return { gifts, subtotal, count, threshold, qualifies: conversion > 0 && subtotal > threshold };
  };
  const plan = cart => {
    const s = state(cart);
    const updates = {};
    let retained = false;
    const existing = s.gifts.find(item => variants.some(v => v.id === Number(item.variant_id)));
    if (!chosenByCustomer && existing) chosen = Number(existing.variant_id);
    for (const item of s.gifts) {
      const keep = s.qualifies && !retained && Number(item.variant_id) === Number(chosen) && item.properties?._FTC_GIFT_VERSION === 'NOV2026';
      const quantity = keep ? 1 : 0;
      if (keep) retained = true;
      if (quantity !== item.quantity) updates[item.key] = quantity;
    }
    return { state: s, updates, add: s.qualifies && !retained && Boolean(chosen) };
  };
  const json = async response => {
    let data;
    try { data = await response.json(); } catch (_) { throw new Error(config.messages.error); }
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : config.messages.error);
    if (data.sections) sections = data.sections;
    return data;
  };
  const getCart = () => rawFetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }).then(json);
  const post = (path, body) => {
    const sectionId = document.querySelector('[data-ftc-cart-template]')?.dataset.ftcSectionId;
    if (sectionId) { body.sections = [sectionId]; body.sections_url = root + 'cart'; }
    return rawFetch(root + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(json);
  };
  const error = message => {
    document.querySelectorAll('[data-ftc-promo-error]').forEach(node => { node.textContent = message || ''; node.hidden = !message; });
  };
  const render = cart => {
    lastCart = cart;
    renderDrawer(cart);
    const s = state(cart);
    document.querySelectorAll('[data-ftc-november]').forEach(card => {
      card.querySelector('[data-ftc-offer-status]').textContent = s.count === 0 ? config.messages.choose : s.count % 2 ? config.messages.one_more : config.messages.pairs.replace('__COUNT__', String(Math.floor(s.count / 2)));
      const gift = s.gifts.find(item => Number(item.product_id) === Number(config.giftProductId));
      const status = !s.qualifies ? config.messages.remaining.replace('__AMOUNT__', money(Math.max(1, s.threshold + 1 - s.subtotal))) : !chosen ? config.messages.unavailable : gift ? gift.final_line_price === 0 ? config.messages.added : config.messages.pending : config.messages.unlocked;
      card.querySelector('[data-ftc-gift-status]').textContent = status;
      const progress = Math.min(100, Math.floor(s.subtotal * 100 / (s.threshold + 1)));
      card.querySelector('[data-ftc-gift-progress]').style.width = progress + '%';
      card.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', String(progress));
      card.querySelector('[data-ftc-gift-size-wrap]').hidden = !s.qualifies || !variants.length;
      const select = card.querySelector('[data-ftc-gift-size]');
      if (!select.options.length) variants.forEach(v => select.add(new Option(v.title, v.id)));
      select.value = String(chosen);
    });
  };
  const refresh = () => {
    const current = document.querySelector('[data-ftc-cart-template]');
    const html = current && sections?.[current.dataset.ftcSectionId];
    if (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('.ftc-cart-template__inner');
      if (fresh) {
        current.querySelector('.ftc-cart-template__inner').innerHTML = fresh.innerHTML;
        document.dispatchEvent(new CustomEvent('ftc:cart-rendered'));
      }
    }
    sections = null;

  };
  const sync = (options = {}) => {
    if (options.refresh !== false) refreshWanted = true;
    if (running) { rerun = true; return running; }
    running = (async () => {
      let cart;
      let changed = false;
      let rounds = 0;
      do {
        rerun = false;
        cart = await getCart();
        let p = plan(cart);
        if (Object.keys(p.updates).length) {
          cart = await post('cart/update.js', { updates: p.updates });
          changed = true;
          p = plan(cart);
        }
        if (p.add) {
          await post('cart/add.js', { items: [{ id: chosen, quantity: 1, properties: { _FTC_USA_GIFT: 'true', _FTC_PROMO: 'REF2025_TABLA_221', _FTC_GIFT_VERSION: 'NOV2026' } }] });
          cart = await getCart();
          const verified = plan(cart);
          if (Object.keys(verified.updates).length) cart = await post('cart/update.js', { updates: verified.updates });
          changed = true;
        }
      } while (rerun && ++rounds < 8);
      if (refreshWanted && (changed || sections)) refresh();
      render(cart);
      error('');
      return cart;
    })().catch(failure => {
      error(failure.message || config.messages.error);
      throw failure;
    }).finally(() => { running = null; refreshWanted = false; });
    return running;
  };
  const schedule = () => { clearTimeout(timer); timer = setTimeout(() => sync().catch(() => {}), 60); };
  const mutation = (url, method) => {
    try {
      const path = new URL(url, location.href);
      return path.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(path.pathname) && String(method || 'GET').toUpperCase() === 'POST';
    } catch (_) { return false; }
  };
  window.fetch = function(input, init) {
    const url = typeof input === 'string' || input instanceof URL ? String(input) : input.url;
    const method = init?.method || input?.method;
    return rawFetch(input, init).then(response => { if (response.ok && mutation(url, method)) { schedule(); if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(url)) openDrawer(false); } return response; });
  };
  window.FTCNovemberPromo = { sync, state, plan, render, config, open:openDrawer, close:closeDrawer };
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-ftc-gift-size]')) return;
    const id = Number(event.target.value);
    if (!variants.some(v => v.id === id)) return;
    chosen = id;
    chosenByCustomer = true;
    sync().catch(() => {});
  });
  document.addEventListener('ftc:cart-rendered', () => { if (lastCart) render(lastCart); });
  document.addEventListener('click', event => {
    const link = event.target.closest('a.js-cart-btn-checkout, a[href="/checkout"]');
    if (!link || event.metaKey || event.ctrlKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    link.setAttribute('aria-busy', 'true');
    sync().then(() => { location.href = link.href; }).catch(() => { link.removeAttribute('aria-busy'); });
  }, true);
  let focusBeforeDrawer;
  let previousOverflow = '';
  let lineQueue = Promise.resolve();
  const node = (tag, className, text) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  };
  function renderDrawer(cart) {
    const drawer = document.querySelector('[data-ftc-drawer]');
    if (!drawer) return;
    const m = config.messages.drawer;
    const list = drawer.querySelector('[data-ftc-drawer-items]');
    list.replaceChildren();
    cart.items.forEach(item => {
      const gift = automatic(item);
      const line = node('article', 'ftc-drawer-line' + (gift ? ' ftc-drawer-line--gift' : ''));
      const imageLink = node('a', 'ftc-drawer-line__image');
      imageLink.href = item.url;
      if (item.image) {
        const image = node('img');
        const imageUrl = new URL(item.image, location.origin);
        imageUrl.searchParams.set('width', '180');
        image.src = imageUrl.href; image.alt = item.product_title; image.width = 88; image.height = 110; image.loading = 'lazy';
        imageLink.append(image);
      }
      const info = node('div', 'ftc-drawer-line__info');
      const title = node('a', 'ftc-drawer-line__title', item.product_title);
      title.href = item.url; info.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') info.append(node('p', 'ftc-drawer-line__variant', item.variant_title));
      if (gift) info.append(node('strong', 'ftc-drawer-line__badge', config.messages.added && item.final_line_price === 0 ? config.messages.added : config.messages.pending));
      const controls = node('div', 'ftc-drawer-line__controls');
      if (!gift) {
        const qty = node('div', 'ftc-drawer-line__quantity');
        const minus = node('button', '', '−'); minus.type = 'button'; minus.dataset.ftcLineKey = item.key; minus.dataset.ftcQuantity = String(Math.max(0, item.quantity - 1)); minus.setAttribute('aria-label', m.minus);
        const input = node('input'); input.type = 'number'; input.min = '0'; input.step = '1'; input.value = item.quantity; input.dataset.ftcLineInput = item.key; input.setAttribute('aria-label', item.product_title + ' · ' + m.subtotal); input.inputMode = 'numeric';
        const plus = node('button', '', '+'); plus.type = 'button'; plus.dataset.ftcLineKey = item.key; plus.dataset.ftcQuantity = String(item.quantity + 1); plus.setAttribute('aria-label', m.plus);
        qty.append(minus, input, plus);
        const remove = node('button', 'ftc-drawer-line__remove', m.remove); remove.type = 'button'; remove.dataset.ftcLineKey = item.key; remove.dataset.ftcQuantity = '0'; controls.append(qty, remove);
      }
      info.append(controls);
      const price = node('div', 'ftc-drawer-line__price');
      if (item.original_line_price > item.final_line_price) price.append(node('s', '', money(item.original_line_price)));
      price.append(node('strong', '', money(item.final_line_price)));
      line.append(imageLink, info, price); list.append(line);
    });
    drawer.querySelector('[data-ftc-drawer-count]').textContent = '(' + cart.item_count + ')';
    drawer.querySelector('[data-ftc-drawer-empty]').hidden = cart.item_count > 0;
    drawer.querySelector('[data-ftc-drawer-total]').textContent = money(cart.total_price);
    drawer.querySelector('[data-ftc-drawer-checkout]').disabled = cart.item_count === 0;
    const savings = drawer.querySelector('[data-ftc-drawer-savings]');
    savings.hidden = !cart.total_discount;
    savings.textContent = m.saved + ' ' + money(cart.total_discount || 0);
    document.querySelectorAll('.js-cart-count').forEach(el => { el.textContent = '(' + cart.item_count + ')'; });
  }
  function openDrawer(check = true) {
    const drawer = document.querySelector('[data-ftc-drawer]');
    const overlay = document.querySelector('[data-ftc-drawer-overlay]');
    if (!drawer || !overlay) return;
    if (drawer.hidden) {
      focusBeforeDrawer = document.activeElement; previousOverflow = document.body.style.overflow;
      drawer.hidden = false; overlay.hidden = false; document.body.style.overflow = 'hidden';
      drawer.focus();
    }
    if (check) sync().catch(() => {});
  }
  function closeDrawer() {
    const drawer = document.querySelector('[data-ftc-drawer]');
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true; document.querySelector('[data-ftc-drawer-overlay]').hidden = true;
    document.body.style.overflow = previousOverflow;
    if (focusBeforeDrawer?.isConnected) focusBeforeDrawer.focus();
  }
  function changeLine(key, quantity) {
    if (!Number.isInteger(quantity) || quantity < 0) return;
    const drawer = document.querySelector('[data-ftc-drawer]');
    drawer?.setAttribute('aria-busy', 'true');
    drawer?.querySelectorAll('button,select,input').forEach(el => { el.disabled = true; });
    lineQueue = lineQueue.catch(() => {}).then(async () => {
      await post('cart/change.js', { id:key, quantity });
      await sync();
    }).catch(failure => { error(failure.message || config.messages.error); }).finally(() => {
      drawer?.removeAttribute('aria-busy');
      drawer?.querySelectorAll('button,select,input').forEach(el => { el.disabled = false; });
      if (lastCart) drawer.querySelector('[data-ftc-drawer-checkout]').disabled = lastCart.item_count === 0;
    });
    return lineQueue;
  }
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-ftc-cart-open],.js-toggle-cart,.js-cart-btn-cart,a[href="/cart"]:not([data-ftc-full-cart])');
    if (open && !event.metaKey && !event.ctrlKey) { event.preventDefault(); event.stopImmediatePropagation(); openDrawer(); return; }
    if (event.target.closest('[data-ftc-drawer-close],[data-ftc-drawer-overlay]')) { event.preventDefault(); closeDrawer(); return; }
    const quantity = event.target.closest('[data-ftc-line-key]');
    if (quantity) { event.preventDefault(); changeLine(quantity.dataset.ftcLineKey, Number(quantity.dataset.ftcQuantity)); return; }
    const checkout = event.target.closest('[data-ftc-drawer-checkout]');
    if (checkout) {
      event.preventDefault(); checkout.disabled = true;
      lineQueue.then(() => sync()).then(cart => { if (cart.item_count > 0) location.href = root + 'checkout'; }).catch(() => { checkout.disabled = false; });
    }
  }, true);
  document.addEventListener('change', event => {
    if (event.target.matches('[data-ftc-line-input]')) changeLine(event.target.dataset.ftcLineInput, Number(event.target.value));
  });
  document.addEventListener('keydown', event => {
    const drawer = document.querySelector('[data-ftc-drawer]');
    if (!drawer || drawer.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); closeDrawer(); }
    if (event.key === 'Tab') {
      const elements = [...drawer.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled])')].filter(el => el.getClientRects().length);
      const first = elements[0], last = elements[elements.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === drawer)) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, location.href);
    if (action.origin !== location.origin || !/\/cart\/add(?:\.js)?$/.test(action.pathname)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (form.dataset.ftcAdding === 'true' || !form.reportValidity()) return;
    form.dataset.ftcAdding = 'true';
    const buttons = [...form.querySelectorAll('[type="submit"]')];
    buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy','true'); });
    try {
      const response = await rawFetch(root + 'cart/add.js', {method:'POST',credentials:'same-origin',headers:{Accept:'application/json'},body:new FormData(form)});
      await json(response); openDrawer(false); await sync();
    } catch (failure) { openDrawer(false); error(failure.message || config.messages.error); }
    finally { form.dataset.ftcAdding = 'false'; buttons.forEach(button => { button.disabled = false; button.removeAttribute('aria-busy'); }); }
  }, true);
  if (window.PerformanceObserver) {
    const observer = new PerformanceObserver(list => {
      for (const entry of list.getEntries()) {
        const path = new URL(entry.name, location.href);
        if (path.origin === location.origin && /\/cart\/(add|change|update|clear)(?:\.js)?$/.test(path.pathname)) {
          schedule(); if (/\/cart\/add/.test(path.pathname)) openDrawer(false);
        }
      }
    });
    observer.observe({type:'resource',buffered:false});
  }

  const start = () => {
    if (window.jQuery) window.jQuery(document).ajaxComplete((event, xhr, settings) => { if (xhr.status < 400 && mutation(settings.url, settings.type)) { schedule(); if (/\/cart\/add/.test(settings.url)) openDrawer(false); } });
    sync().catch(() => {});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  window.addEventListener('pageshow', event => { if (event.persisted) schedule(); });
})();

